export default "__VITE_ASSET__BdkKYNVT__"